import {getUnsentCardLogs, markCardLogsSent} from './cardPaymentLog'
import {getUnsentErrorLogs, markErrorLogsSent} from './errorLog'

// Tipovi koji okidaju trenutno (debounced) slanje na server + e-mail.
// Sve ostalo se šalje samo kroz periodični flush ili manualni gumb.
const CRITICAL_TYPES = new Set([
    // Card payment — neuspjeh ili sumnjivo stanje
    'INIT_ERR',
    'TIMEOUT_ERR',
    'TIMEOUT_CANCEL_ERR',
    'CANCEL_ERR',        // samo stvarni kvar; odbijeni otkaz je CANCEL_REJECTED i nije kritican
    'REFUND_ERR',
    'MANUAL_CONFIRM_UNVERIFIED',  // racun izdan bez potvrde naplate kod Teye
    'SALE_FAIL',
    'SALE_ERR',
    // Globalni JS bugovi
    'JS_ERR',
    'PROMISE_ERR',
])

const DIAGNOSTIC_ENDPOINT = '/diagnostic-logs'
const DEBOUNCE_MS = 15000           // čekaj 15s nakon kritičnog eventa, da se grupira okolni kontekst
const PERIODIC_INTERVAL_MS = 60 * 60 * 1000  // 60 min safety net
const INITIAL_DELAY_MS = 30000       // 30s nakon boot-a, jednom

let debounceTimer = null
let periodicTimer = null
let initialTimer = null
let flushInProgress = false

export const isLogSenderEndpoint = (url) => {
    if (!url) return false
    return url.includes(DIAGNOSTIC_ENDPOINT)
}

const buildContext = () => {
    let device = {}
    try {
        device = JSON.parse(localStorage.getItem('invoiceDevice') || '{}')
    } catch (_) {}
    return {
        invoice_device_id: device.id,
        invoice_device_name: device.full_name,
        user_id: localStorage.getItem('user_id'),
        username: localStorage.getItem('user_username'),
        app_version: process.env.REACT_APP_POS_VERSION,
        user_agent: typeof navigator !== 'undefined' ? navigator.userAgent : '',
        url: typeof window !== 'undefined' ? window.location?.pathname : '',
        sent_at: new Date().toISOString(),
    }
}

export const flushLogs = async ({manual = false} = {}) => {
    if (flushInProgress) return {skipped: true}
    if (!window.axios) return {skipped: true, reason: 'no_axios'}
    if (!localStorage.getItem('token')) return {skipped: true, reason: 'no_auth'}

    flushInProgress = true
    try {
        const cardEntries = getUnsentCardLogs()
        const errorEntries = getUnsentErrorLogs()

        if (cardEntries.length === 0 && errorEntries.length === 0 && !manual) {
            return {sent: 0}
        }

        const isCritical = !manual && [...cardEntries, ...errorEntries].some((e) => CRITICAL_TYPES.has(e.type))

        const payload = {
            card_entries: cardEntries,
            error_entries: errorEntries,
            is_critical: isCritical,
            manual: manual,
            context: buildContext(),
        }

        const {data, status} = await window.axios.post(DIAGNOSTIC_ENDPOINT, payload)

        if (status >= 200 && status < 300 && data?.success !== false) {
            markCardLogsSent(cardEntries.map((e) => e.ts))
            markErrorLogsSent(errorEntries.map((e) => e.ts))
            return {sent: cardEntries.length + errorEntries.length, critical: isCritical}
        }
        return {error: data?.error || `status ${status}`}
    } catch (e) {
        return {error: e?.message || 'network error'}
    } finally {
        flushInProgress = false
    }
}

export const sendAllLogsManual = () => flushLogs({manual: true})

export const notifyCriticalIfNeeded = (type) => {
    if (!CRITICAL_TYPES.has(type)) return
    if (debounceTimer) clearTimeout(debounceTimer)
    debounceTimer = setTimeout(() => {
        debounceTimer = null
        flushLogs({manual: false}).catch(() => {})
    }, DEBOUNCE_MS)
}

export const installLogSender = () => {
    if (initialTimer || periodicTimer) return
    initialTimer = setTimeout(() => {
        initialTimer = null
        flushLogs({manual: false}).catch(() => {})
    }, INITIAL_DELAY_MS)
    periodicTimer = setInterval(() => {
        flushLogs({manual: false}).catch(() => {})
    }, PERIODIC_INTERVAL_MS)
}
